/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.directives.module.ts" />
/// <reference path="OrsumTable.Controller.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../../common/services/apiservice.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />

module App.Common.Directives {
	'use strict';

	export class OrsumTableDirective implements angular.IDirective {
		private uniqueName: string;

		public static $inject = ['$compile'];

		public constructor(private $compile: any) {
		}

		public restrict = 'E';

		public controller = Common.Controllers.OrsumTableController; //['$scope', '$injector', 'navigationHelper', Common.Controllers.OrsumTableController];

		public controllerAs = 'ost';

		public bindToController = false;

		public transclude = false;

		public scope: boolean | { [index: string]: string; } = { 'ostConfig': '=' };

		public link = (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ctrl: any, compile: any) => {
			let config = scope['ostConfig'];
			this.uniqueName = scope['ostConfig']['uniqueName'];
			let html = this.getTemplate(config);
			element[0].innerHTML = html;
			this.$compile(element.contents())(scope);
		};

		/**
		 * No template is specified as it is modified and set in the Link function
		 */
		public template = '';

		/**
		 * Generate the html template, modifying the html with the supplied configuration
		 * @param config
		 */
		private getTemplate(config: Common.Controllers.OrsumTableConfig): string {
			let i = 0;
			let result = '<div class="table-tools">';
			result += '<style>@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) { .ieFilter {padding-top:0 !important; color: #ababab;} .ieFilter.ng-not-empty { color: #000 !important;} }</style>';
			result += '<!--Group By-->';
			result += '<div class="group-by">';
			result += '<label>Group By</label>';
			result += '<div class="btn-group">';
			result += '<button class="btn btn-primary dropdown-toggle" aria-expanded="false" aria-haspopup="true" type="button" data-toggle="dropdown">';
			result += '<span ng-if="!ost.groupByColumnSelected">Select Column </span>';
			result += '<span ng-if="ost.groupByColumnSelected">{{ost.getColumnDisplayName(ost.groupByColumnId)}}</span>';
			result += ' <span class="caret"></span>';
			result += '</button>';
			result += '<ul class="dropdown-menu">';
			result += '<li ng-click="ost.setGroupBy(\'None\')"><a href="#">None</a></li>';
			result += '<li class="divider" role="separator"></li>';
			for (i = 0; i < config.columns.length; i++) {
				result += `<li ng-click="ost.setGroupBy(\'${config.columns[i].columnId}\')"><a href="#">${config.columns[i].columnDisplayName}</a></li>`;
			}
			result += '</ul>';
			result += '</div>';
			result += '</div>';
			result += '<!--Filter By-->';
			result += '<div class="filter">';
			result += '<label>Filter</label>';
			result += '<div class="btn-group">';
			result += '<button class="btn btn-primary dropdown-toggle" aria-expanded="false" aria-haspopup="true" type="button" data-toggle="dropdown">';
			result += '<span ng-if="!ost.filterByColumnSelected">All Columns <span class="caret"></span></span>';
			result += '<span ng-if="ost.filterByColumnSelected">{{ost.getColumnDisplayName(ost.filterByColumnId)}}</span>';
			result += '</button>';
			result += '<ul class="dropdown-menu">';
			result += '<li ng-click="ost.setFilterBy(\'All Columns\')"><a href="#">All Columns</a></li>';
			result += '<li class="divider" role="separator"></li>';
			for (i = 0; i < config.columns.length; i++) {
				if (!config.columns[i].notSortable) {
					result += `<li ng-click="ost.setFilterBy(\'${config.columns[i].columnId}\')"><a href="#">${config.columns[i].columnDisplayName}</a></li>`;
				}
			}
			result += '</ul>';
			result += '</div>';
			result += '<input type="text" ng-model="ost.filterBy" ng-model-options="{debounce:300}" ng-change="ost.recalcTableData()" ng-blur="ost.recalcTableData()" placeholder="Filter" class="ieFilter" />';
			result += '</div>';
			result += '</div>';
			result += '<div class="table-wrap">';
			result += '<!--The table of data-->';
			if (!!config.tableClass) {
				result += `<table ng-attr-id="{{\'orsumTable\' + $id}}" class="table orsum-table ${config.tableClass}" ng-init="ost.registerTable($id)">`;
			}
			else result += '<table ng-attr-id="{{\'orsumTable\' + $id}}" class="table orsum-table" ng-init="ost.registerTable($id)">';
			result += '<thead>';
			result += '<tr>';
			for (i = 0; i < config.columns.length; i++) {
				result += `<th ng-class="{\'tablesort-asc\': !ost.sortByColumnReverse && ost.sortByColumnId === \'${config.columns[i].columnId}\', \'tablesort-desc\': ost.sortByColumnReverse && ost.sortByColumnId === \'${config.columns[i].columnId}\'}">`;
				if (!config.columns[i].notSortable) {
					result += `<a id="colHeader${config.columns[i].columnId}" href="#" ng-click="ost.setSortBy(\'${config.columns[i].columnId}\');">`;
				}
				result += config.columns[i].columnDisplayName;
				if (!config.columns[i].notSortable) {
					result += '</a>';
				}
				result += '</th>';
			}
			result += '</tr>';
			result += '</thead>';
			//display initialising if no data provided
			result += '<tbody ng-if="!ost.hasInitialised">';
			result += '<tr >';
			result += `<th colspan="${config.columns.length}"><i>Waiting for the data to initialise...</i></th>`;
			result += '</tr>';
			result += '</tbody>';
			//display no rows if no rows
			result += '<tbody ng-if="ost.hasInitialised && ost.getTotalRows() === 0">';
			result += '<tr >';
			result += `<th colspan="${config.columns.length}"><i>No data</i></th>`;
			result += '</tr>';
			result += '</tbody>';
			//display rows of grouped data if rows found
			result += '<tbody ng-if="ost.hasInitialised && ost.getTotalRows() > 0" ng-repeat="i in ost.getGroupIndex(ost.getNumberOfGroups()) track by $index">';
			result += '<tr ng-attr-id="{{\'expalapse\' + $id}}" ng-show="ost.getNumberOfGroups() > 1" id="expandable" class="group-header expand" ng-click="ost.expandCollapseToggle(this)">';
			result += `<th colspan="${config.columns.length}"><span class="sign" aria-hidden="true"></span>{{ost.getGroupKey($index)}}</th>`;
			result += '</tr>';
			result += `<tr ng-repeat="row in ost.getGroup($index)" ${(config.rowClick ? 'class="clickable"' : '')}>`;
			for (i = 0; i < config.columns.length; i++) {
				var click = `${(config.rowClick && !config.columns[i].notClickable ? ` ng-click="${config.rowClick}"` : '')}`;
				if (config.columns[i].columnDisplayTemplate) {
					result += `<td${click}>${config.columns[i].columnDisplayTemplate}</td>`;
				} else if (config.columns[i].columnDisplayTemplateHtml) {
					result += `<td${click} ng-bind-html="${config.columns[i].columnDisplayTemplateHtml}"></td>`;
				} else {
					result += `<td${click}>&nbsp;</td>`;
				}
			}
			result += '</tr>';
			result += '</tbody>';
			result += '</table>';
			result += '</div>';
			return result;
		}

		/**
		 * Generate the table td's, one for each column in the config
		 * @param config
		 */
		private generateTemplateRowTd(config: Common.Controllers.OrsumTableConfig): string {
			let result = '';
			if (!!(config)) {
				for (var i = 0; i < config.columns.length; i++) {
					result += `<td>${config.columns[i].columnDisplayTemplate}</td>`;
				}
			}
			return result;
		}

	}

	factory.$inject = ['$compile'];
	/**
	 * factory method used so that $compile can be injected
	 * @param $compile
	 */
	function factory($compile: angular.ICompileProvider) {
		return new OrsumTableDirective($compile);
	}

	angular.module('app.common.directives').directive('orsumTable', factory);
}


